import { render, staticRenderFns } from "./confirm3Button.vue?vue&type=template&id=4fd08518&"
import script from "./confirm3Button.vue?vue&type=script&lang=js&"
export * from "./confirm3Button.vue?vue&type=script&lang=js&"
import style0 from "./confirm3Button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports